<template>
    <!-- tab头部吸顶-->
    <div class="basic-tab-header">
        <div ref="fakeHeader" :style="blankStyle"></div>
        <div
            class="basic-tab-header-real"
            :style="{ ...finalHeaderStyle, ...headerBgColor }"
            ref="header"
            :class="{ 'basic-tab-fixed-header': fixed && !shouldHide }"
        >
            <template v-if="!scrollFlag">
                <template v-for="item of tpl.children">
                    <a
                        href="javascript:void(0)"
                        :key="'part' + item.id"
                        class="basic-tab-part"
                        @click="clickMe($event, item)"
                        :class="{ active: activeChild === item, circle: tabType === TAB_TYPE.CIRCLE }"
                        :style="activeChild === item ? headerItemActiveStyle : headerItemStyle"
                    >
                        <span v-html="item.props.title"></span>
                    </a>
                </template>
                <div
                    class="basic-tab-header-active-bar"
                    :style="headerActiveBarStyle"
                    v-if="tabType === TAB_TYPE.LINE"
                ></div>
            </template>
            <div class="basic-tab-header-scroll" :style="xOffsetStyle" v-else>
                <template v-for="item of tpl.children">
                    <a
                        href="javascript:void(0)"
                        :key="'part' + item.id"
                        class="basic-tab-part"
                        @click="clickMe($event, item)"
                        :class="{ active: activeChild === item, circle: tabType === TAB_TYPE.CIRCLE }"
                        :style="activeChild === item ? headerItemActiveStyle : headerItemStyle"
                    >
                        <span v-html="item.props.title"></span>
                    </a>
                </template>
                <div
                    class="basic-tab-header-active-bar"
                    :style="headerActiveBarStyle"
                    v-if="tabType === TAB_TYPE.LINE"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
const { throttle } = require('@futuweb/fego-bridge');
const {
    common: {
        env: { isPreRender }
    }
} = require('@futuweb/fego-render');
import { TAB_TYPE } from '../constant';

export default {
    props: {
        tabType: {
            type: Number,
            default: TAB_TYPE.LINE
        },
        fixed: {
            type: Boolean,
            default: false
        },
        tpl: {
            type: Object
        },
        value: {},
        bodyEl: {},
        headerStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        headerScrollStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        headerItemStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        headerItemActiveStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        headerActiveBarStyle: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            TAB_TYPE,
            shouldHide: true,
            finalHeaderStyle: {},
            offsetx: 0,
            scrollFlag: true
        };
    },
    computed: {
        activeId: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            }
        },
        activeChild() {
            return (
                this.tpl.children.find((i) => {
                    return i.id === this.activeId;
                }) || this.tpl.children[0]
            );
        },
        blankStyle() {
            if (!this.shouldHide) {
                const { height } = this.$refs.header.getBoundingClientRect();
                return `height:${height}px`;
            } else {
                return ''; // 默认不显示
            }
        },
        xOffsetStyle() {
            return `transform: translateX(${this.offsetx}px);`;
        },
        headerBgColor() {
            if (this.fixed) {
                return {
                    backgroundColor: this.tpl.style.backgroundColor
                };
            }
            return {};
        }
    },
    mounted() {
        this.fixed && this.fresh();

        // 计算header最长宽度
        if (this.$el.getBoundingClientRect) {
            const headerWidth = this.$el.getBoundingClientRect().width;
            this.finalHeaderStyle = Object.assign(
                headerWidth ? {
                    maxWidth: headerWidth + 'px'
                } : {},
                this.headerStyle
            );
            // 预渲染不执行
            if (!isPreRender) {
                // 判断是否需要滚动， 宽度不超过时不需要滚动；
                const xline = this.$el.querySelector('.basic-tab-header-scroll');
                if (xline) {
                    const { width: wn } = this.$refs.header.getBoundingClientRect();
                    const { width: w1 } = xline.getBoundingClientRect();
                    this.scrollFlag = w1 > wn;
                    console.error('=====22222===', this.scrollFlag);
                }
            }
        }
    },
    watch: {
        activeId: {
            immediate: true,
            handler() {
                this.$nextTick(() => {
                    this.scrollFlag && this.scollActiveToCenter();
                });
            }
        }
    },
    methods: {
        // 监听滚动事件
        watchToHide(btn) {
            const maxHeight = document.documentElement.clientHeight;
            const fn = () => {
                this.shouldHide = true;
                const { top } = btn.getBoundingClientRect();
                const { top: topOfTab, bottom: btOfTab } = this.$parent.$el.getBoundingClientRect();
                // tab 在可见区域才可能展示fixed部分， 并且 basic-tab-header 不再可视区域
                const tabIsOutOfView = !(btOfTab >= maxHeight / 2 && topOfTab <= maxHeight);
                const tabHeadIsInView = top <= maxHeight && top >= 0;
                this.shouldHide = tabIsOutOfView || tabHeadIsInView;
            };
            if (!this.scroll) {
                this.scroll = throttle(fn, 100);
                window.addEventListener('scroll', this.scroll);
            }
        },
        unWatch() {
            if (this.scroll) {
                window.removeEventListener('scroll', this.scroll);
                this.scroll = null;
            }
        },
        fresh() {
            try {
                this.unWatch();
                this.watchToHide(this.$refs.fakeHeader);
            } catch (err) {
                console.error('=====fresh======', err);
            }
        },
        scollActiveToCenter() {
            this.$nextTick(
                // eslint-disable-next-line prefer-arrow-callback
                function () {
                    const active = this.$el.querySelector('.basic-tab-part.active');
                    const xline = this.$el.querySelector('.basic-tab-header-scroll');

                    // console.error('--------scollActiveToCenter--------', active, xline)

                    // 横向滚动
                    // 如果当前tab不完全显示，滚动其到中间
                    const { left: l0, right: w0 } = active.getBoundingClientRect();
                    const { left: ln, width: wn } = this.$refs.header.getBoundingClientRect();
                    const { left: l1, width: w1 } = xline.getBoundingClientRect();
                    const max = (w1 - wn) / 2;
                    if (max > 0) {
                        // 左边第一个tab刚好左侧对齐
                        const maxOffset = this.offsetx + ln - l1;
                        // 右边第一个tab刚好右侧对齐
                        const minOffset = maxOffset - 2 * max;

                        // 当前tab卡片中心距离父节点最左侧的距离 l0 - l1 + w0/2
                        // 整个tab组件可视头部的宽度 wn/2
                        const offset = l0 - l1 + w0 / 2 - wn / 2;
                        this.offsetx = maxOffset - offset;

                        // 左侧第一个tab不能再右移
                        this.offsetx = Math.min(this.offsetx, maxOffset);
                        // 右侧一个tab不能再左移
                        this.offsetx = Math.max(this.offsetx, minOffset);
                    } else {
                        this.offsetx = 0;
                    }
                }.bind(this)
            );
        },
        clickMe($event, v) {
            this.activeId = v.id;
            const nav = this.$el;
            const navHeight = nav.offsetHeight; // 导航栏高度
            // 垂直滚动
            try {
                if (this.fixed) {
                    const { y: y1 } = this.bodyEl.getBoundingClientRect();
                    const { y: y2 } = document.body.getBoundingClientRect();
                    const top = y1 - y2 - navHeight;
                    window.scrollTo(0, top);
                }
            } catch (err) {
                console.error('=======clickMe=======', err);
            }
        }
    },
    beforeDestroy() {
        this.unWatch();
    }
};
</script>
<style scoped lang="less">
@import url(../common.less);

.basic-tab-header {
    width: 100%;
}
</style>
